import Vue from "vue"
import View from "./core/View"

Vue.component("core-view", View)
